module.exports = {
      id: "ic-csv-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-csv-usage",
      toString: function () {
        return this.url;
      }
    }